module.exports = __webpack_public_path__ + "static/project-1-6575e316b81484ca5f59fc4e22e60014.jpg";